import {useEffect, useState} from 'react';

export const getOutlookMailboxUserEmail = (): string | undefined => {
  if (typeof Office === 'undefined') {
    return undefined;
  }
  const addr = Office.context.mailbox.userProfile?.emailAddress;
  if (typeof addr !== 'string' || !addr.trim()) {
    return undefined;
  }
  return addr.trim();
};

export const getIsOutlookMailItemActive = (): boolean => {
  if (typeof Office === 'undefined') {
    return false;
  }
  const item = Office.context.mailbox.item;
  if (item == null) {
    return false;
  }
  return item.itemType === Office.MailboxEnums.ItemType.Message;
};

export type OutlookMailboxUiContext = {
  mailboxEmail: string | undefined;
  isMailItemActive: boolean;
};

export const useOutlookMailboxUiContext = (): OutlookMailboxUiContext => {
  const [mailboxEmail, setMailboxEmail] = useState<string | undefined>(() =>
    getOutlookMailboxUserEmail()
  );
  const [isMailItemActive, setIsMailItemActive] = useState(() =>
    getIsOutlookMailItemActive()
  );

  useEffect(() => {
    const sync = () => {
      setMailboxEmail(getOutlookMailboxUserEmail());
      setIsMailItemActive(getIsOutlookMailItemActive());
    };

    sync();

    const mailbox =
      typeof Office !== 'undefined' ? Office.context?.mailbox : undefined;

    const onVisible = () => {
      if (document.visibilityState === 'visible') {
        sync();
      }
    };

    window.addEventListener('focus', sync);
    document.addEventListener('visibilitychange', onVisible);

    if (mailbox?.addHandlerAsync) {
      mailbox.addHandlerAsync(Office.EventType.ItemChanged, sync, () => {});
    }

    return () => {
      window.removeEventListener('focus', sync);
      document.removeEventListener('visibilitychange', onVisible);

      if (mailbox?.removeHandlerAsync) {
        mailbox.removeHandlerAsync(Office.EventType.ItemChanged, () => {});
      }
    };
  }, []);

  return {mailboxEmail, isMailItemActive};
};
